import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AttachShowroomIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M14.1133 3.23328L9.09997 0.333276C8.43997 -0.106724 7.55331 -0.106724 6.92664 0.313276L1.83997 3.26661C1.18664 3.69994 0.806641 4.35994 0.806641 5.06661V10.9333C0.806641 11.7066 1.24664 12.4466 1.87331 12.7533L6.89997 15.6666C7.54664 16.0999 8.43331 16.1133 9.07331 15.6866L14.1666 12.7333C14.82 12.2999 15.1933 11.6399 15.1933 10.9333V5.06661C15.1933 4.29994 14.76 3.56661 14.1133 3.23328ZM13.86 10.9333C13.86 11.2799 13.5866 11.5133 13.46 11.5999L8.36664 14.5533C8.14664 14.6999 7.85997 14.6999 7.60664 14.5333L2.50664 11.5799C2.29997 11.4733 2.13997 11.1999 2.13997 10.9333V5.06661C2.13997 4.71994 2.41331 4.47994 2.53997 4.39994L7.63331 1.44661C7.86664 1.29328 8.15997 1.31328 8.39331 1.46661L13.4533 4.39994C13.6866 4.49994 13.8533 4.78661 13.8533 5.06661V10.9333H13.86Z"
        fill={color}
      />
      <path
        d="M11.2 5.75996L8.33334 4.0933C8.12667 3.9733 7.87334 3.9733 7.66667 4.0933L4.80001 5.75996C4.59334 5.87996 4.46667 6.09996 4.46667 6.3333V9.66663C4.46667 9.90663 4.59334 10.1266 4.80001 10.24L7.66667 11.9066C7.87334 12.0266 8.12667 12.0266 8.33334 11.9066L11.2 10.24C11.4067 10.12 11.5333 9.89996 11.5333 9.66663V6.3333C11.5333 6.0933 11.4067 5.8733 11.2 5.75996ZM8.00001 5.43996L9.55334 6.34663L8.00001 7.2333L6.44667 6.34663L8.00001 5.43996ZM5.80001 7.5133L7.33334 8.38663V10.1733L5.80001 9.27996V7.50663V7.5133ZM8.66667 10.1733V8.38663L10.2 7.5133V9.28663L8.66667 10.18V10.1733Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AttachShowroomIcon.displayName = 'AttachShowroomIcon';
